module.exports = __webpack_public_path__ + "img/android.9f7fcc29.png";